import { render, staticRenderFns } from "./SitemapSetting.vue?vue&type=template&id=24a446e9&"
import script from "./SitemapSetting.vue?vue&type=script&lang=js&"
export * from "./SitemapSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports